export const UPDATE_FORM_DATA = "UPDATE_FORM_DATA";
export const REINITIALIZE_FORM_DATA = "REINITIALIZE_FORM_DATA";
export const UPDATE_PROFILE_PHOTO = "UPDATE_PROFILE_PHOTO";

export const SAVE_FORM_STATE = "SAVE_FORM_STATE";
export const LOAD_FORM_STATE = 'LOAD_FORM_STATE';

export const TOGGLE_SIGNUP_METHOD = "TOGGLE_SIGNUP_METHOD";

export const SET_TEMP_USER_ID = "SET_TEMP_USER_ID";
export const CLEAR_TEMP_USER_ID = "CLEAR_TEMP_USER_ID";
